import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';

import moment from 'moment';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/components/shared/api.service';
import { SharedService } from 'src/app/components/shared/shared.service';
import { localStorageService } from 'src/app/components/shared/localstorage.service';
import { MainService } from 'src/app/components/shared/main.service';
import { Subscription } from 'rxjs';
import { AddEditTrainingComponent } from 'src/app/components/shared/add-edit-training/add-edit-training.component';
import { AddNotesComponent } from 'src/app/components/shared/add-notes/add-notes.component';


@Component({
  selector: 'app-training-details',
  templateUrl: './training-details.component.html',
  styleUrls: ['./training-details.component.scss'],
  providers:[DatePipe]
})
export class TrainingDetailsComponent implements OnInit, OnDestroy {
  id: any;
  trainingInfo: any = {};
  trainingNotes: any = [];
  timezones: any = [];
  selectedAppt: any = null;
  today: Date = new Date();
  dateConfig: any = {
    containerClass: 'theme-blue',
    placement: 'left',
    dateInputFormat: 'MM-DD-YYYY'
  };
  admins:any = [];

  newNote!: string;
  trainingTypes:any = [];
  timezone: any = '';
  timezoneName: any = '';
  aptCount:any;
  bsModalRef!: BsModalRef;
  //currentUrl = "";
  timezoneSubscription!: Subscription;
  paramSubscription!: Subscription;
  queryParamSubscription!: Subscription;
  api_hit = true;
  detail_in_notification = false;
  @ViewChild('apptModal') apptModal!: ModalDirective;
  country_id: any = '';
  doctor_partner_type: any;
  req_id: any;
  trainingStatus: string = ''; 
  timezoneFullName: any;
  timezoneOffset: any;

  // Notes filter bar (Date Range / Admin / Search), ported from CommonNotesListingComponent's "Notes" tab --
  // ticket-status checkboxes and the "Notes with ticket" dropdown were intentionally left out, since Training
  // notes have no ticket linkage to filter by. Training notes are fetched wholesale (no server-side filtered
  // endpoint), so this filters the already-loaded trainingNotes array client-side.
  filteredTrainingNotes: any[] = [];
  notesAdminList: any[] = [];
  notesDateRangeValue: any;
  notesResetBtn: boolean = false;
  notesMinimumDate: Date = new Date(2023, 0, 1);
  notesMaximumDate: Date = new Date();
  notesSelectedAdminId: any = 0;
  notesSearchString: string = '';

  constructor(
    public mainService: MainService,
    public route: ActivatedRoute,
    public location:Location,
    public datePipe:DatePipe,
    public modalService:BsModalService,
    public router: Router,
    private _api: ApiService,
    public _shared: SharedService,
    private _local: localStorageService
  ) { }

  ngOnInit() {
    //this.currentUrl = window.location.pathname;
    // this.timezoneSubscription = this._shared.timezone$.subscribe((value: any) => {
    //     this.timezoneName = value.name;
    // });
    this.notesAdminList = this._shared.getAdminList();
    this.notesDateRangeValue = [this.notesMinimumDate, this.notesMaximumDate];
    this.paramSubscription = this.route.params.subscribe((param: any) => {
      this.id = this._shared.resolveRouteId(param.id, 'Training');
      this.trainingInfo = {};
      this.trainingNotes = [];
      this.api_hit = true;
    });
    this._shared.timezoneName$.subscribe(response => {
      if (response && response.length) {
        this.timezones = []
        const data = this._shared.getTimezoneList();
        for (var i = 0; i < data.length; i++) {
          if (data[i].val) {
            var tzOffset = (parseInt(data[i].val.substring(0, data[i].val.length - 2)) * 60) + parseInt(data[i].val.substring(data[i].val.length - 2));
            var timezoneHours = parseInt((parseInt((tzOffset + "")) / 60) + "");
            timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
            var timezoneMinutes = (tzOffset % 60);
            timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
            var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;
            this.timezones.push({
              code: data[i].offset,
              name: data[i].name,
              tzOffset: tzOffset,
              timezoneString: timezoneString,
              country_id: data[i].country_id,
              val: data[i].val,
              offset: data[i].offset,
              zone: data[i].zone,
            });
          }
          if (i === data.length - 1) {
            this.timezoneName = this.timezones && this.timezones.find((id: any) => id.val == this.timezone)?.code;
            console.log(this.timezoneName);
          }
        }
      }
    });
    
    this.queryParamSubscription = this.route.queryParams.subscribe((params: any) => {
      this.timezone = params['timezone'];
      // this.timezones = this._shared.getTimezoneList();
      this.timezoneName = this.timezones && this.timezones.find((id: any) => id.val == this.timezone)?.offset;
      console.log('test', this.timezoneName);
      this.req_id = params['reqid'];
      if (this.id) {
        this.getTrainingDetails(this.id);
      }
    });
    
    this.today.setHours(0,0,0,0);
    this.getTrainingTypes();
    if (this.router.url.indexOf('/app/dashboard/notifications/') !== -1) {
      this.detail_in_notification = true;
    }
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }

  getTrainingTypes(){
    let params = {};
    this._api.api(params, 'scheduler/fetch_training_types', 'get')
      .subscribe((data:any)=>{
        if(data.is_error == 0) this.trainingTypes = data.data;
      }, (error:any)=>{
        console.log(error);
      })
  }

  onTrainingSelect(){
    let index = this.trainingTypes.findIndex((x: any) => x.type_id == this.selectedAppt.training);
    this.selectedAppt.duration = this.trainingTypes[index].duration;
  }

  getTimezoneOffsetString(tzOffset: any){
    var timezoneHours = parseInt((parseInt((tzOffset+""))/60)+"");
    timezoneHours = timezoneHours < 0 ? (-1*timezoneHours) : timezoneHours;
    var timezoneMinutes = (tzOffset%60);
    timezoneMinutes = timezoneMinutes < 0 ? (-1*timezoneMinutes) : timezoneMinutes;
    var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0":"") + timezoneHours +":"+(timezoneMinutes < 10 ? "0":"") + timezoneMinutes;
    return timezoneString;
  }

  getDateTimeFromTimestampWithFormat(timestamp: any, format: any, utcOffset: any) {
    let dateObj = moment( (+timestamp) * 1000);
    if (utcOffset !== null || utcOffset !== undefined) {
      dateObj = dateObj.utcOffset(utcOffset);
    }
    return dateObj.format(format);
  }

  getTrainingDetails(id: any) {
    let data = {
      
      event_id: id,
    }
    this._api.api(data, 'scheduler/get_event_details', 'get')
      .subscribe((data: any) => {
        if (data.is_error == 1) {
          if(this.req_id){

          }
          if (this.router.url.indexOf('/app/notifications/') !== -1) {
            this._shared.customPopups('This training has either been rescheduled or canceled', 2);
            this.api_hit = false;
          } else {
            this._shared.customPopups('This training has either been rescheduled or canceled', 1);
            //this.mainService.flagPopUps(data.flag, data.is_error);
            this.router.navigate(['/app/training/training-list']);
          }
        }
        else
        {
          this.trainingInfo = data.eventData;

          this.doctor_partner_type = this.trainingInfo.training_doctor_partner_type
          //let selectedUtcOffset = this.getTimezoneOffsetFromString(this.timezone);
          // this.trainingInfo.training_timezone_offset
          // trainingInfo.training_timezone_short_name

          let applicableOffset = this.getApplicableOffsetBasedOnDaylight(this.trainingInfo.training_timezone_short_name, String(this.trainingInfo.training_timezone_offset));
          // alert(this.timezoneName);
          let schedule_date = moment(parseInt(this.trainingInfo.training_start_timestamp)*1000).utcOffset(applicableOffset).format("MM/DD/YYYY");
          let schedule_time = moment(parseInt(this.trainingInfo.training_start_timestamp)*1000).utcOffset(applicableOffset).format("hh:mm A");
          this.trainingInfo.timezoneName = this.timezoneName;
          this.trainingInfo.schedule_date = schedule_date;
          this.trainingInfo.schedule_time = schedule_time;
          this.trainingInfo.timezoneString = this.getTimezoneOffsetString(applicableOffset);
          this.trainingNotes = data.trainingNotes;
          this.computeNoteDisplayAttachments(this.trainingNotes);
          this.applyNotesFilters();
          const filterItem = this.timezones.find((item: any) => item.offset === this.timezoneName);
          this.trainingInfo.timezoneFullName = this.timezoneFullName;
          console.log(filterItem?.zone);
          this.trainingStatus = String(this.trainingInfo.training_status).trim();
          // if (this.trainingInfo.training_timezone_short_name != filterItem.offset){
          //   this.trainingInfo.schedule_date = moment(this.trainingInfo.followup_date).tz(filterItem?.zone).format('MM/DD/YYYY')
          //   this.trainingInfo.schedule_time = moment(this.trainingInfo.followup_date).tz(filterItem?.zone).format('hh:mm A')
          // }else {
          //   this.trainingInfo.schedule_date = this.datePipe.transform(this.trainingInfo.followup_date, 'MM/dd/yyyy', 'UTC')!;
          //   this.trainingInfo.schedule_time = this.datePipe.transform(this.trainingInfo.followup_date, 'hh:mm a', 'UTC')!;
          // }
        }
        
        /*this.selectedAppt = JSON.parse(JSON.stringify(data.request[0]));
        // this.selectedAppt.schedule_date = data.request[0].schedule_date;
        // console.log(this.mainService.getUTCDate(data.request[0].schedule_date));
        // this.selectedAppt.schedule_date = new Date(this.mainService.getUTCDate(data.request[0].schedule_date));
        this.selectedAppt.schedule_date = this.datePipe.transform(data.request[0].schedule_date, 'MM-dd-yyyy', '+0000');
        this.trainingInfo.schedule_date = this.datePipe.transform(data.request[0].schedule_date, 'MM-dd-yyyy', '+0000');
        let time = this.trainingInfo.schedule_time ? this.trainingInfo.schedule_time.split(':') : [];
        let date = new Date();
        if (date && typeof (date) == 'object') {
          var d = date.getDate(),
            m = date.getMonth(),
            y = date.getFullYear();
        }

        if (time && time.length) {
          var hour = time[0], minutes = time[1];
        }
        this.trainingInfo['time'] = new Date(y, m, d, hour, parseInt(minutes));
        var timezoneVal = parseInt(this.trainingInfo.schedule_timezone);
        var timezoneName = 'UTC';
        this.timezones.forEach((timezone: any) => {
          if (timezoneVal == parseInt(timezone.val)) {
            timezoneName = timezone.offset;
            this.trainingInfo.timezone = timezoneName;
            this.selectedAppt.offset = timezoneName;
          }
        });

        this.trainingNotes = data.notes;
        this.trainingNotes.forEach((item: any) => {
          if (item.admin_id == JSON.parse(MainService.customGetItem('profileData'))[0].admin_id) {
            item.me = true;
          } else {
            item.me = false;
          }
        });*/
      })
  }

  getApplicableOffsetBasedOnDaylight(tzShortCode: any, tzOffset: any) {
    let selectedUtcOffset = this.getTimezoneOffsetFromString(this.timezone);
    let trainingTzObj = this.timezones.find((tz: any) => tz.offset === tzShortCode);
    if (!trainingTzObj) {
      let alternateTrainingTzObj = this.timezones.find((tz: any) => tz.alternate_daylight_code === tzShortCode);
      if (alternateTrainingTzObj) {
        selectedUtcOffset += (tzOffset - this.getTimezoneOffsetFromString(alternateTrainingTzObj.val));
      }
    }
    return selectedUtcOffset;
  }

  getTimezoneOffsetFromString(timezoneString: any) {
    return (parseInt(timezoneString.substring(0, timezoneString.length - 2))*60) + parseInt(timezoneString.substring(timezoneString.length - 2));
  }

  pastDate(date: any) {
    let selectedDate = new Date(moment(date).format('YYYY-MM-DD'));
    let today = new Date(moment().format('YYYY-MM-DD'));
    if (selectedDate < today) {
      return true;
    } else {
      return false;
    }
  }

  updateEvent(form: any) {
    console.log(form)
    // if (this.pastDate(new Date(this.selectedAppt.schedule_date)) && this.selectedAppt.status != 7) {
    //   this._shared.customPopups('Please select a new date', 2);
    //   return false;
    // }
    if (form.invalid) {
      this._shared.customPopups('Please fill all the required fields', 2);
      return false;
    }
    if(!this.selectedAppt.admin_id){
      this._shared.customPopups('Please assign a CSR to the appointment.', 2);
      return false;
    }
    
    let data = {
      
      training_id: this.selectedAppt.training_id,
      schedule_date: moment(form.value.aptDate).format('YYYY-MM-DD'),
      schedule_time: moment(form.value.aptTime).format('HH:mm'),
      schedule_timezone: form.value.aptTimezone,
      note: form.value.aptNote,
      status: form.value.aptStatus,
      admin_id: this.selectedAppt.admin_id,
      duration: form.value.aptDuration,
      type: form.value.aptTraining
    };
    this._api.api(data, 'edit_doctor_training')
      .subscribe((data: any) => {
        console.log(data);
        if (data.is_error == 0) {
          // this.getTrainings();
          this.getTrainingDetails(this.id);
          this.hideEventModal();
          form.reset();
          // this.selectedAdmin = 0;
          this.selectedAppt.admin_name = '';
        }
      });
      return;
  }

  hideEventModal(): void {
    console.log('modalhide')
    this.apptModal.hide();
  }

  fetchAvailableAdminList(event:any) {
    let data: any = {
      
      schedule_time: this.selectedAppt.schedule_time?this.selectedAppt.schedule_time:'',
      schedule_timezone: this.selectedAppt.schedule_timezone?this.selectedAppt.schedule_timezone:'',
      duration: this.selectedAppt.duration?this.selectedAppt.duration:0,
      schedule_date: this.selectedAppt.schedule_date?moment(this.selectedAppt.schedule_date).format("YYYY-MM-DD"):''
    };
    if(!data.schedule_date){
      this._shared.customPopups('Please select date first', 2);
      return false;
    }
    if(!data.schedule_time){
      this._shared.customPopups('Please select time first', 2);
      return false;
    }
    if(!data.duration){
      this._shared.customPopups('Please select duration first', 2);
      return false;
    }
    if(!data.schedule_timezone){
      this._shared.customPopups('Please select timezone first', 2);
      return false;
    }
    if ((event && event.length > 3)) {
      data['search_string'] = event;
    } else {
      return false;
    }
    this._api.api(data, 'fetch_available_admins')
      .subscribe((data: any) => {
        if (data.data && data.data.length) {
          this.admins = data.data;
        }
      });
      
      return;
  }

  selectNewAdmin(event:any){
    console.log(event)
    if(event && event.length>0){
      if(event[0].data.is_available){
        this.selectedAppt.admin_id = event[0].data.admin_id;
      }else{
        this._shared.customPopups('CSR not available in given time slot', 2);
        this.admins = [];
        this.selectedAppt.admin_id='';
        return false;
      }
    }else{
      this.admins = [];
      this.selectedAppt.admin_id='';
    }
    
    return;
  }

  newAdminClear(event: any) {
    if (event.length == 0) {
      this.selectedAppt.admin_id = 0;
      this.selectedAppt.admin_name = '';
    }
  }

  addNote(form: any, modal: any) {
    let data = {
      
      training_id: this.id,
      note: this.newNote
    };
    if (this.newNote && this.newNote.trim().length == 0) {
      this._shared.customPopups('Please enter a valid note', 2);
      return false;
    }
    this._api.api(data, 'add_doctor_training_note')
      .subscribe((res: any) => {
        console.log(res);
        if (res.is_error == 0) {
          modal.hide();
          form.reset();
          this.getTrainingDetails(this.id);
        }
      })
      return;
  }

  openAddNoteModal() {
    const initialState = {
      data: {
        allow_special_note: true,
        training_event_time_slot_id: this.id,
        admin_id: this.trainingInfo.training_admin_id
      }
    };
    this.mainService.noteadded = false;
    this.bsModalRef = this.modalService.show(AddNotesComponent, { initialState, class: 'modal-lg', ignoreBackdropClick: true });
    this.modalService.onHide.subscribe((reason: string) => {
      if (this.mainService.noteadded) {
        this.getTrainingDetails(this.id);
      }
    });
  }

  computeNoteDisplayAttachments(notes: any[]) {
    const seen = new Set<string>();
    const chronological = (notes || []).slice().reverse();
    chronological.forEach((note: any) => {
      const attachments = note.attachments || [];
      note.displayAttachments = attachments.filter((doc: any) => doc && doc.file_url && !seen.has(doc.file_url));
      attachments.forEach((doc: any) => {
        if (doc && doc.file_url) {
          seen.add(doc.file_url);
        }
      });
    });
  }

  applyNotesFilters() {
    let filtered = (this.trainingNotes || []).slice();
    if (this.notesDateRangeValue && this.notesDateRangeValue[0] && this.notesDateRangeValue[1]) {
      const start = moment(this.notesDateRangeValue[0]).startOf('day');
      const end = moment(this.notesDateRangeValue[1]).endOf('day');
      filtered = filtered.filter((note: any) => {
        const created = moment(note.doctor_partner_training_status_date_created);
        return created.isValid() && created.isSameOrAfter(start) && created.isSameOrBefore(end);
      });
    }
    if (this.notesSelectedAdminId) {
      filtered = filtered.filter((note: any) => note.creator_admin_id == this.notesSelectedAdminId);
    }
    if (this.notesSearchString && this.notesSearchString.trim()) {
      const term = this.notesSearchString.trim().toLowerCase();
      filtered = filtered.filter((note: any) => (note.training_event_desc || '').toLowerCase().includes(term));
    }
    this.filteredTrainingNotes = filtered;
  }

  notesDateChange() {
    this.notesResetBtn = true;
    this.applyNotesFilters();
  }

  notesResetDate() {
    this.notesDateRangeValue = [this.notesMinimumDate, this.notesMaximumDate];
    this.notesResetBtn = false;
    this.applyNotesFilters();
  }

  notesSelectAdmin(event: any) {
    this.notesSelectedAdminId = event;
    this.applyNotesFilters();
  }

  notesAdminClear(event: any) {
    if (event.length == 0) {
      this.notesSelectedAdminId = 0;
      this.applyNotesFilters();
    }
  }

  notesResetSearch() {
    this.notesSearchString = '';
    this.applyNotesFilters();
  }

  addTrainingNotesModal(){
    var event_id = this.id;
        
    var initialState = {
        data: {
            eventId: event_id,
            timezones: this.timezones,
            viewType: "updateTrainingNotes",
            minTimeGap: 15,
        }
    }
    var thisRef = this;
    this.bsModalRef = this.modalService.show(AddEditTrainingComponent, { initialState, class: 'modal-lg', ignoreBackdropClick:true  });
    this.modalService.onHide.subscribe((reason: string) => {
        if (this.bsModalRef.content.trainingCreated) {
          //console.log('appointment closed')
          //alert("dfd");
          this.getTrainingDetails(this.id);
        }
    });
  }

  editTrainingModal(){
    
    var event_id = this.id;
        
    var initialState = {
        data: {
            eventId: event_id,
            timezones: this.timezones,
            viewType: "rescheduleTraining",
            minTimeGap: 15,
            country_id:this.country_id,
            doctor_partner_type: this.doctor_partner_type
        }
    }
    var thisRef = this;
    this.bsModalRef = this.modalService.show(AddEditTrainingComponent, { initialState, class: 'modal-lg', ignoreBackdropClick:true  });
    this.modalService.onHide.subscribe((reason: string) => {
        if (this.bsModalRef.content.trainingCreated) {
          //console.log('appointment closed')
          //alert("dfd");
          if(this.bsModalRef.content.trainingCreated.newEventId)
          {
            //this.getTrainingDetails(this.id);
            var pathnameParts =  window.location.pathname.split("/");
            pathnameParts[pathnameParts.length-1] = this.bsModalRef.content.trainingCreated.newEventId;

            //this.currentUrl = pathnameParts.join("/");
            window.history.replaceState({}, "Credee - Admin Panel", pathnameParts.join("/"));
            this.id = this.bsModalRef.content.trainingCreated.newEventId;
            this.getTrainingDetails(this.bsModalRef.content.trainingCreated.newEventId);
          }
          else
          {
            this.getTrainingDetails(this.id);
          }
        }
    });

    /*// setting time and date for selected event
    console.log(this.selectedAppt);
    let time = this.selectedAppt.schedule_time.split(':');
    let newTime = new Date();
    newTime.setHours(time[0]);
    newTime.setMinutes(time[1]);
    this.selectedAppt.time = newTime;
    this.selectedAppt.training = this.selectedAppt.type;
    this.selectedAppt.detailPage = true;
    let initialState = {data:this.selectedAppt};
    if (initialState) {
      this.bsModalRef = this.modalService.show(EditTrainingComponent, { initialState, class: 'modal-lg', ignoreBackdropClick:true  });
    } else {
      this.bsModalRef = this.modalService.show(EditTrainingComponent, { class: 'modal-lg', ignoreBackdropClick:true  });
    }
    this.aptCount = 0;
    this.modalService.onHide.subscribe((reason: string) => {
      if (this.aptCount == 1) {
        return false;
      }
      if (this.bsModalRef.content.trainingEdited) {
        console.log('appointment edited closed')
        this.aptCount = 1;
        this.getTrainingDetails(this.id)
      }
    })
      // this.apptModal.show();*/
  }

  changeAssignee() {
    const event_id = this.id;

    const trainingTime = this.getDateTimeFromTimestampWithFormat(this.trainingInfo.training_start_timestamp, 'hh:mm A', this.trainingInfo.training_timezone_offset)

    const ts = this.trainingInfo.training_start_timestamp;

    // 1️⃣ Read from DB
    const trainingDate = getTrainingDateFromTimestamp(ts);

    // 2️⃣ Apply current system time
    const updatedDate = applyCurrentSystemTime(trainingDate);

    // 3️⃣ Display (UI)
    console.log(updatedDate.toString());

    const timezoneOfferHour = convertMinutesToHHMM(this.trainingInfo.training_timezone_offset);

    this.timezoneFullName = this.timezones && this.timezones.find((id: any) => id.val == this.timezone)?.name;
    this.timezoneOffset = this.timezone;

    const initialState = {
      data: {
        ...this.trainingInfo,
        eventId: event_id,
        timezones: this.timezones,
        timezoneOffset: this.timezoneOffset,
        timezoneFullName: this.timezoneFullName,
        timezoneOfferHour,
        originalTimezoneOffset: this.trainingInfo.training_timezone_offset,
        startDate: updatedDate.toString(),
        endDate: moment(updatedDate.toString()).add(1, 'days').format('YYYY-MM-DD'),
        viewType: "changeAssignee",
        trainingType: 'editTraining',
        country_id: this.country_id,
        doctor_partner_type: this.doctor_partner_type,
        trainingTime,
        startDateString: updatedDate.toString(),
        minTimeGap: 15
      }
    }

    this.bsModalRef = this.modalService.show(AddEditTrainingComponent, { initialState, class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: true });
    this.modalService.onHide.subscribe((reason: any) => {
      if (this.bsModalRef.content?.changeAssignee?.assigneeChanged) {
        var pathnameParts = window.location.pathname.split("/");
        pathnameParts[pathnameParts.length - 1] = this.bsModalRef.content.changeAssignee.newEventId;
        window.history.replaceState({}, "Recuvery - Admin Panel", pathnameParts.join("/"));

        this.id = this.bsModalRef.content.changeAssignee.newEventId;
        this.getTrainingDetails(this.bsModalRef.content.changeAssignee.newEventId);

      } else if (this.bsModalRef.content.rescheduleTraining) {
        this.editTrainingModal()
      }
    });
  }

  goBack() {
    this.router.navigate(['/app/training/training-list']);
  }

}


function getTrainingDateFromTimestamp(ts: number): Date {
  // Converts UTC timestamp → LOCAL (PST) date
  return new Date(ts * 1000);
}

function applyCurrentSystemTime(date: Date): Date {
  const now = new Date();

  const updated = new Date(date); // clone
  updated.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    0
  );

  return updated;
}

function convertHHMMtoMinutes(hhmm: number): number {
  const sign = hhmm < 0 ? -1 : 1;
  hhmm = Math.abs(hhmm);
  const hours = Math.floor(hhmm / 100);
  const minutes = hhmm % 100;
  return sign * (hours * 60 + minutes);
}

function convertMinutesToHHMM(totalMinutes: number): number {
  const sign = totalMinutes < 0 ? -1 : 1;
  totalMinutes = Math.abs(totalMinutes);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return sign * (hours * 100 + minutes);
}
